import React from "react";
import styles from "./ContactFaqOne.module.scss";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Button from "../../../components/UI/button";
import { IoIosArrowRoundDown } from "react-icons/io";
import { Link } from "react-router-dom";

const ContactFaqOne = () => {
  return (
    <div className="voopo__faq__area pb--120 bg--white" id="faqs">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6">
            <Accordion defaultActiveKey="0" className={styles.panoraAccordion}>
              <Card className={styles.card}>
                <Card.Header className={styles.accHeader}>
                  <h5>
                    <Accordion.Toggle variant="link" eventKey="0">
                      What services does Adaptive Systems LLC provide?{" "}
                      <span>
                        <IoIosArrowRoundDown />
                      </span>
                    </Accordion.Toggle>
                  </h5>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <div className={styles.cardBody}>
                      We help you compare internet, TV, and phone plans from leading providers in your area.
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card className={styles.card}>
                <Card.Header className={styles.accHeader}>
                  <h5>
                    <Accordion.Toggle variant="link" eventKey="1">
                      Can I bundle Internet, TV, and Phone together?{" "}
                      <span>
                        <IoIosArrowRoundDown />
                      </span>
                    </Accordion.Toggle>
                  </h5>
                </Card.Header>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <div className={styles.cardBody}>
                      Yes. Bundles may offer discounts and the convenience of one bill. Call +1 (877) 514-5141 to see current offers.
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card className={styles.card}>
                <Card.Header className={styles.accHeader}>
                  <h5>
                    <Accordion.Toggle variant="link" eventKey="2">
                      How fast is the Internet?{" "}
                      <span>
                        <IoIosArrowRoundDown />
                      </span>
                    </Accordion.Toggle>
                  </h5>
                </Card.Header>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <div className={styles.cardBody}>
                      Plans are available up to 1 Gbps in select areas. Availability depends on your ZIP code.
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card className={styles.card}>
                <Card.Header className={styles.accHeader}>
                  <h5>
                    <Accordion.Toggle variant="link" eventKey="3">
                      Do you require long-term contracts?{" "}
                      <span>
                        <IoIosArrowRoundDown />
                      </span>
                    </Accordion.Toggle>
                  </h5>
                </Card.Header>
                <Accordion.Collapse eventKey="3">
                  <Card.Body>
                    <div className={styles.cardBody}>
                      Most plans are flexible. Contract terms depend on the provider and location.
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card className={styles.card}>
                <Card.Header className={styles.accHeader}>
                  <h5>
                    <Accordion.Toggle variant="link" eventKey="4">
                      How do I sign up?{" "}
                      <span>
                        <IoIosArrowRoundDown />
                      </span>
                    </Accordion.Toggle>
                  </h5>
                </Card.Header>
                <Accordion.Collapse eventKey="4">
                  <Card.Body>
                    <div className={styles.cardBody}>
                      Enter your ZIP code to check availability, or call +1 (877) 514-5141 to speak with a specialist.
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </div>
          <div className="col-12 col-lg-6 sm__mt--40 md__mt--40 xs__mt--40">
            <div className={styles.faqInner}>
              <div className={styles.content}>
                <h2>Still Have Questions?</h2>
                <p>
                  Our team is here to help you choose the right Internet, TV, or Phone plan for your home or business. Fill out the form below and one of our specialists will contact you shortly.
                </p>
                <div className={styles.inputBox}>
                  <input type="text" placeholder="Full Name" />
                  <input type="email" placeholder="Email" />
                  <input type="text" placeholder="Phone" />
                  <input type="text" placeholder="ZIP" maxLength={5}/>
                  <div className={styles.checkBoxDiv}>
                    <input type="checkbox" id="check" name="check" className={styles.checkBox} required/>
                    <label for="check">By clicking “Submit,” you agree that Adaptive Systems LLC and its partners may contact you at the phone number and email provided about available offers using automated technology (calls, texts, emails). Consent is not required to purchase. Msg & data rates may apply. Opt out anytime.</label>
                  </div>
                  <div className={styles.note}>
                    <span>Privacy Note:</span>
                    <p>We respect your privacy. See our <Link to="privacy-policy">Privacy Policy</Link> for details.</p>
                  </div>
                  <div className={styles.qusBtn}>
                    <Button type="button" text="Submit" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactFaqOne;
